import { http } from '@haohan/clw-utils'

const PermissionBasePath = '/api/v1/permission'

/**
 * 权限新增
 */
export function projectAddPermissionReq(params: any) {
  return http.request({
    method: 'post',
    url: `${PermissionBasePath}`,
    data: params
  })
}
/**
 * 权限编辑
 */
export function projectEditPermissionReq(id: any, params: any) {
  return http.request({
    method: 'put',
    url: `${PermissionBasePath}/${id}`,
    data: params
  })
}
/**
 * 权限删除
 */
export function projectDelPermissionReq(id: any) {
  return http.request({
    method: 'delete',
    url: `${PermissionBasePath}/${id}`
  })
}
/**
 * 权限列表查询
 */
export function projectQueryPermissionListReq(params: any) {
  return http.request({
    method: 'post',
    url: `${PermissionBasePath}/query`,
    data: params
  })
}
/**
 * 获取权限树
 */
export function projectQueryPowerTreeReq() {
  return http.request({
    method: 'get',
    url: `${PermissionBasePath}/tree`
  })
}
